export var PaymentRequestApprovalStatus;
(function (PaymentRequestApprovalStatus) {
    PaymentRequestApprovalStatus["PENDING"] = "PENDING";
    PaymentRequestApprovalStatus["NOT_PENDING"] = "NOT_PENDING";
})(PaymentRequestApprovalStatus || (PaymentRequestApprovalStatus = {}));
export var PaymentRequestStatus;
(function (PaymentRequestStatus) {
    PaymentRequestStatus["AWAITING_MY_APPROVAL"] = "AWAITING_MY_APPROVAL";
    PaymentRequestStatus["AWAITING_APPROVAL"] = "AWAITING_APPROVAL";
})(PaymentRequestStatus || (PaymentRequestStatus = {}));
